class EventBus extends EventTarget {
  dispatch(eventName, detail) {
    const anyEvent = new CustomEvent("any", { detail: { eventName, data: detail } });
    this.dispatchEvent(anyEvent);
  }
}

const eventBus = new EventBus();
export default eventBus;
